export enum PrivilegeEnum {
  LeadsAdd = 'leads:add',
  OfferSave = 'offers:save',
  Registered = 'registered',
  ServiceChatStart = 'service-chat:start',
}
